<template>
  <div>
    <div class="image-grid">
      <draggable
        v-model="images"
        draggable=".image-card"
        handle=".drag-handle"
        ghostClass="drag-ghost"
        dragClass="drag-item"
        tag="div"
        class="image-grid-inner">
        <div
          v-for="(image, index) in images"
          :key="image.id"
          class="image-card"
          :class="{ primary: index === 0 }">
          <div class="drag-handle">
            <b-icon icon="drag" size="is-small" />
          </div>
          <img :src="image.src" />
          <div class="image-card-actions">
            <button class="image-card-btn image-card-btn--delete" @click="removeImage(image, index)" title="Delete image">
              <b-icon icon="delete" size="is-small" />
            </button>
          </div>
        </div>
      </draggable>
      <!-- Placeholder when non-hero images are odd count -->
      <div
        v-if="showPlaceholder"
        class="image-card image-upload"
        @click="openAddImage">
        <b-icon icon="plus" />
        <span>Add image</span>
      </div>
    </div>
    <!-- Hidden EditImage for add flow -->
    <EditImage
      ref="newImage"
      isNew
      style="display:none"
      @add-image="addImage($event)"
    />
  </div>
</template>

<script>
import EditImage from "@/components/EditImage.vue"
import Draggable from 'vuedraggable'

export default {
  name: 'EditImages',
  components: {
    EditImage,
    Draggable
  },
  props: {
    value: {
      type: Array,
      default: function () { return [] }
    }
  },
  computed: {
    images: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    },
    showPlaceholder() {
      return this.images.length > 0 && (this.images.length - 1) % 2 === 1
    }
  },
  methods: {
    openAddImage() {
      this.$refs.newImage.selectImage()
    },
    addImage(newImage) {
      this.images.push(newImage);
      this.$emit('input', this.images)
    },
    removeImage(image, index) {
      this.$delete(this.images, index);
      this.$emit('input', this.images)
    }
  }
}
</script>

<style scoped>
.image-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
}

.image-grid-inner {
  display: contents;
}

.image-card {
  aspect-ratio: 1;
  border-radius: var(--radius-md);
  overflow: hidden;
  position: relative;
  background: var(--bg-tertiary);
}

.image-card img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.image-card.primary {
  grid-column: span 2;
  aspect-ratio: 1;
}

/* Drag handle */
.drag-handle {
  position: absolute;
  top: 10px;
  left: 10px;
  width: 32px;
  height: 32px;
  background: white;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 6px rgba(0,0,0,0.04), 0 10px 20px rgba(0,0,0,0.06);
  cursor: grab;
  opacity: 0;
  transition: opacity 0.2s;
  z-index: 2;
}

.image-card:hover .drag-handle {
  opacity: 1;
}

/* Floating actions (delete button) */
.image-card-actions {
  position: absolute;
  top: 10px;
  right: 10px;
  display: flex;
  gap: 6px;
  opacity: 0;
  transition: opacity 0.2s;
  z-index: 2;
}

.image-card:hover .image-card-actions {
  opacity: 1;
}

.image-card-btn {
  width: 32px;
  height: 32px;
  background: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 6px rgba(0,0,0,0.04), 0 10px 20px rgba(0,0,0,0.06);
  transition: transform 0.15s;
}

.image-card-btn:hover {
  transform: scale(1.05);
}

.image-card-btn--delete:hover {
  background: #fef2f2;
  color: #dc2626;
}

/* Dashed placeholder for adding images */
.image-upload {
  border: 2px dashed var(--border-medium);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  cursor: pointer;
  transition: all 0.2s;
  color: var(--text-muted);
  background: transparent;
}

.image-upload:hover {
  border-color: var(--feeds-green);
  color: var(--feeds-green);
  background: var(--feeds-green-light);
}

.image-upload span {
  font-size: 13px;
  font-weight: 500;
}

/* Drag ghost */
.drag-ghost {
  opacity: 0.4;
}

/* Touch devices: always show handles and actions */
@media (hover: none) {
  .drag-handle {
    opacity: 0.7;
  }

  .image-card-actions {
    opacity: 1;
  }
}
</style>
